// extracted by css-extract-rspack-plugin
export default {"cls1":"ZeroState-cls1_Gg5","cls2":"ZeroState-cls2_QlR ZeroState-cls1_Gg5"};